// extracted by mini-css-extract-plugin
export default {"nodeEnterAnimation":"NodeWrapper_nodeEnterAnimation__Gwggw","fadeInUp":"NodeWrapper_fadeInUp__6sAcL"};